import { NgModule } from '@angular/core';
import { CampaignRouteDirective } from './shared/campaign-route.directive';
import { CampaignCrudUrlBuilder } from './shared/crud-url-builder';
import { CampaignUrlBuilder } from './shared/url-builder';

@NgModule({
  declarations: [
    CampaignRouteDirective
  ],
  exports: [
    CampaignRouteDirective
  ],
  providers: [
    CampaignUrlBuilder,
    CampaignCrudUrlBuilder
  ]
})
export class CampaignUtilModule {

}

